var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinner8 = function SvgSpinner8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 32c-4.274 0-8.292-1.664-11.314-4.686S0 20.274 0 16c0-3.026.849-5.973 2.456-8.522a16.06 16.06 0 0 1 6.386-5.791l1.344 2.682a13.04 13.04 0 0 0-5.192 4.708A12.95 12.95 0 0 0 3 15.999c0 7.168 5.832 13 13 13s13-5.832 13-13c0-2.459-.69-4.853-1.994-6.922a13.05 13.05 0 0 0-5.192-4.708l1.344-2.682a16.05 16.05 0 0 1 6.386 5.791A15.95 15.95 0 0 1 32 16c0 4.274-1.664 8.292-4.686 11.314S20.274 32 16 32"
  })));
};
export default SvgSpinner8;